import React from "react";
import { Button, Dialog } from "@sscs/ui";
import { useGetGroupUsageDetailsQuery } from "Services";
import { Group } from "Types";
import { GroupFormPercentageSlider } from "../../types";
import GroupDialogForm from "../GroupDialogForm/GroupDialogForm";
import useEditGroupForm from "./useEditGroupForm";

const filestreamPercentageFieldName: keyof GroupFormPercentageSlider =
  "filestream_percentage";
const projectsPercentageFieldName: keyof GroupFormPercentageSlider =
  "projects_percentage";

type EditGroupProps = {
  isOpen: boolean;
  showSSOGroupMapping: boolean;
  group: Group;
  onClose: () => void;
  totalPortalCapacity?: number;
};

const EditGroupContent = ({
  group,
  onClose,
  showSSOGroupMapping,
  totalPortalCapacity,
}: Omit<EditGroupProps, "isOpen">): React.JSX.Element => {
  const { data } = useGetGroupUsageDetailsQuery({
    groupId: group.group_id,
  });
  const {
    onSubmit,
    errors,
    formMethods,
    filestreamPercentage,
    projectsPercentage,
    onPercentageSliderChange,
    onProjectsPercentageInputChange,
  } = useEditGroupForm({
    filestreamPercentageFieldName,
    projectsPercentageFieldName,
    group,
    onClose,
    totalPortalCapacity,
  });

  return (
    <GroupDialogForm
      totalPortalCapacity={totalPortalCapacity}
      onClose={onClose}
      showSSOGroupMapping={showSSOGroupMapping}
      onSubmit={onSubmit}
      errors={errors}
      formMethods={formMethods}
      title="Edit group"
      filestreamPercentageFieldName={filestreamPercentageFieldName}
      projectsPercentageFieldName={projectsPercentageFieldName}
      filestreamPercentage={filestreamPercentage}
      projectsPercentage={projectsPercentage}
      onPercentageSliderChange={onPercentageSliderChange}
      onProjectsPercentageInputChange={onProjectsPercentageInputChange}
      filestreamUsageBytes={data?.filestream_usage_bytes}
      projectsUsageBytes={data?.projects_usage_bytes}
      submitButton={
        <Button type="submit" color="primary">
          Edit group
        </Button>
      }
    />
  );
};

const EditGroup = ({ isOpen, ...props }: EditGroupProps): React.JSX.Element => (
  <Dialog.Frame size="md" isOpen={isOpen} onClose={props.onClose}>
    <EditGroupContent {...props} />
  </Dialog.Frame>
);

export default EditGroup;
